export default __webpack_public_path__ + "fonts/add-contact-button-pressed.svg";